import { IWPImage, IWPLink } from "@/src/types";
import React from "react";

import { getImage } from "gatsby-plugin-image";

import { Link } from "gatsby";
import S from "./TextWithImageBg.styled";

export interface Props {
  title: string;
  text: string;
  link: IWPLink;
  backgroundImage: IWPImage;
}

const TextWithImageBg: React.FC<Props> = ({
  title,
  text,
  link,
  backgroundImage,
}) => {
  // TODO: Set this image as background image (with 0.09 opacity)
  const BGData = backgroundImage?.localFile?.childImageSharp?.gatsbyImageData
    ? getImage(backgroundImage.localFile.childImageSharp.gatsbyImageData)
    : null;

  return (
    <div className="bg-mGray-100 w-full relative overflow-hidden">

      {BGData && (
        <S.BGImage
          image={BGData}
          alt={"Metlab certifikat"}
          objectFit={"cover"}
          className={"select-none"}
          objectPosition={"center"}
        />
      )}

      <div className={title && title}></div>
      <div className="md:mx-auto md:max-w-7xl px-9 sm:px-2 py-24 relative z-10">
        <h3 className="text-4xl text-center -mt-4 mb-0 py-6">{title && title}</h3>

        <div
          className="mx-auto max-w-2xl text-center"
          dangerouslySetInnerHTML={{ __html: text || '' }}
        ></div>
        <br />
        {link?.url && link?.title && (
          <Link to={link.url} className="mt-4 w-full text-center block">
            <span className="text-center border-metlab-500 border-b-2 font-bold text-metlab-500 text-xl pb-2">
              {link?.title && link.title}
            </span>
          </Link>
        )}
      </div>
    </div>
  );
};

export default TextWithImageBg;
